import InspectionType from "./actionTypes"



// function that called as action
const getOrderList = data => ({
  type: InspectionType.GET_INSPECTION_ORDER_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getOrderListSuccess = data => ({
  type: InspectionType.GET_INSPECTION_ORDER_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getRtwOrderList = (data, action) => ({
  type: InspectionType.GET_INSPECTION_RTW_ORDER_LIST,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getRtwOrderListSuccess = data => ({
  type: InspectionType.GET_INSPECTION_RTW_ORDER_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getOrderDetail = (data, action) => ({
  type: InspectionType.GET_INSPECTION_DETAIL_ORDER,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getOrderDetailSuccess = data => ({
  type: InspectionType.GET_INSPECTION_DETAIL_ORDER_SUCCESS,
  payload: data,
})

// function that called as action
const getRtwOrderDetail = (data, action) => ({
  type: InspectionType.GET_INSPECTION_DETAIL_RTW_ORDER,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getRtwOrderDetailSuccess = data => ({
  type: InspectionType.GET_INSPECTION_DETAIL_RTW_ORDER_SUCCESS,
  payload: data,
})


// function that called as action
const getOrderDetailSize = (data, action) => ({
  type: InspectionType.GET_INSPECTION_DETAIL_ORDER_SIZE,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getOrderDetailSizeSuccess = data => ({
  type: InspectionType.GET_INSPECTION_DETAIL_ORDER_SIZE_SUCCESS,
  payload: data,
})

// function that called as action
const getRtwOrderDetailSize = (data, action) => ({
  type: InspectionType.GET_INSPECTION_DETAIL_RTW_ORDER_SIZE,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getRtwOrderDetailSizeSuccess = data => ({
  type: InspectionType.GET_INSPECTION_DETAIL_RTW_ORDER_SIZE_SUCCESS,
  payload: data,
})

// function that called as action
const postOrderData = (data, action) => ({
  type: InspectionType.POST_ORDER,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postOrderDataSuccess = data => ({
  type: InspectionType.POST_ORDER_SUCCESS,
  payload: data,
})

// function that called as action
const postRtwOrderData = (data, action) => ({
  type: InspectionType.POST_RTW_ORDER,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postRtwOrderDataSuccess = data => ({
  type: InspectionType.POST_RTW_ORDER_SUCCESS,
  payload: data,
})

// function that called as action
const patchDefect = (data, action) => {
  return {
    type: InspectionType.PATCH_DEFECT,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const patchDefectSuccess = data => ({
  type: InspectionType.PATCH_DEFECT_SUCCESS,
  payload: data,
})


// function that called as action
const postOrderMemo = (data, action) => ({
  type: InspectionType.POST_ORDER_MEMO,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postOrderMemoSuccess = data => ({
  type: InspectionType.POST_ORDER_MEMO_SUCCESS,
  payload: data,
})

// function that called as action
const postRtwOrderMemo = (data, action) => ({
  type: InspectionType.POST_RTW_ORDER_MEMO,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postRtwOrderMemoSuccess = data => ({
  type: InspectionType.POST_RTW_ORDER_MEMO_SUCCESS,
  payload: data,
})

const InspectionAction = {
  getOrderList,
  getOrderListSuccess,

  getRtwOrderList,
  getRtwOrderListSuccess,

  getOrderDetail,
  getOrderDetailSuccess,

  getRtwOrderDetail,
  getRtwOrderDetailSuccess,

  getOrderDetailSize,
  getOrderDetailSizeSuccess,

  getRtwOrderDetailSize,
  getRtwOrderDetailSizeSuccess,

  postOrderData,
  postOrderDataSuccess,

  postRtwOrderData,
  postRtwOrderDataSuccess,

  patchDefect,
  patchDefectSuccess,

  postOrderMemo,
  postOrderMemoSuccess,

  postRtwOrderMemo,
  postRtwOrderMemoSuccess

}

export default InspectionAction





